import React from "react";
import vendorbg from "./assets/vendorbg.png";
import { useNavigate } from "react-router-dom";

const VendorCTA = ({ user }) => {
  const navigate = useNavigate();

  const handleClaimClick = () => {
    if (user) {
      navigate('/claimbusiness');
    } else {
      navigate('/signup');
    }
  };

  const handlelistClick = () => {
    if (user) {
      navigate('/submit');
    } else {
      navigate('/signup');
    }
  };


  return (
    // <div
    //   className="mt-28 mb-[90px] md:mb-[60px] lg:mb-[60px] xl:mb-[120px] md:mt-[71px] w-full px-2 rounded-t-[30px] relative h-[405px] md:h-[253px] xl:h-[343px]"
    //   style={{
    //     background:
    //       "linear-gradient(180deg, #FFDDA9 0%, rgba(255, 221, 169, 0) 100%)",
    //   }}
    // >
    //   {/* Image */}
    //   <div className="absolute w-[399px] lg:w-[459px] xl:w-[748px] -left-12 sm:left-14 md:-left-12 -top-24 xl:-top-32 lg:-left-0 xl:-left-0">
    //     <img src={vendorbg} alt="Vendor" className="object-cover" />
    //   </div>

    //   {/* Text + Buttons */}
    //   <div className="absolute -bottom-3 sm:bottom-3  md:bottom-0  lg:bottom-24 flex-col mt-[0] justify-between text-center sm:text-start md:right-9 md:w-[49%] lg:w-[55%] xl:w-[45%]">
    //     <div className="font-bold text-center md:text-left p-[10px] md:p-0">
    //       <p className="text-[22px] md:text-[24px] xl:text-[38px]">
    //         Join our vendor community. Grow your reach!
    //       </p>

    //       <p className="text-[14px] font-medium">
    //         <span className="block lg:inline">
    //           List your business and get customers to share their reviews and
    //           build trust.
    //         </span>
    //       </p>
    //     </div>
    //     <div className="flex flex-col items-center md:items-start lg:flex-row gap-2 ">
    //     <button
    //       onClick={handlelistClick}
    //       className="bg-ravblue text-white text-lg items-center h-[44px] w-[240px]  text-nowrap font-bold py-[10px] rounded-[80px] mt-2"
    //     >
    //       Join as a vendor
    //     </button>

    //     <button

    //       onClick={handleClaimClick}
    //       className="text-black text-nowrap border h-[44px] border-black text-[16px] lg:mt-2 font-bold w-[240px] py-[10px] rounded-[80px] "
    //     >
    //       Claim your business for free
    //     </button>
    //     </div>
    //   </div>
    // </div>

    < div
      className="mt-28 md:mt-[71px] w-full px-2  rounded-t-[30px] relative  h-[405px] sm:h-[360px] md:h-[253px] xl:h-[343px] mb-[134px] md:mb-[70px] lg:mb-[52px]"
      style={{
        background:
          "linear-gradient(180deg, #FFDDA9 0%, rgba(255, 221, 169, 0) 100%)",
      }
      }
    >


      {/* 🖼️ Image Section */}
      {/* <div className=" flex flex-col justify-center absolute -left-6 md:ml-[-20px] xl:ml[-76px] -top-[77px]"> */}
      <div className=" absolute w-[399px] lg:w-[459px] xl:w-[748px] -left-12 -top-24 md:-top-20 -lg:top-18 xl:-top-40 lg:-left-8 xl:-left-24 ">
        <img
          src={vendorbg}
          alt="Vendor"
          className=" object-cover"
        />
      </div>


      {/* 📝 Text + Button Section */}
      <div className=" absolute  -bottom-5 sm:bottom-8 sm:left-8 md:left-auto md:bottom-5 lg:top-3 flex-col justify-between text-center md:text-start md:mt-0 lg:mt-4 md:right-9 md:w-[49%] lg:w-[55%] xl:w-[45%]  ">
        <div className="font-bold text-center md:text-left p-[10px] md:p-0">
          <p className="text-[22px]  md:text-[24px] lg:whitespace-nowrap xl:whitespace-normal xl:text-left xl:text-[38px]">
            Join our vendor community. Grow your reach!
          </p>

          <p className="text-[14px] font-medium ">
            <span className="block lg:inline">
              List your business and get customers to share their reviews and build trust.
            </span>
          </p>
        </div>
        <div className="flex flex-col sm:flex-row md:flex-col lg:flex-row items-center md:items-start lg:items-center mt-6 sm:mt-2 md:mt-2 lg:mt-4 gap-[11px] md:gap-2  lg:gap-[9px] xl:gap-[7.5px]">
          <button
            onClick={handlelistClick}
            className="w-[239px] lg:w-fit bg-ravblue text-white text-lg font-bold px-5 h-[44px] rounded-[80px]  "
          >
            Join as a vendor
          </button>
          <button

            onClick={handleClaimClick}
            className="text-black text-nowrap border h-[44px] border-black text-[16px] font-bold w-[240px]  rounded-[80px] "
          >
            Claim your business for free   </button>
        </div>
      </div>
    </div >


  );
};

export default VendorCTA;
